import React from 'react';

function LoadingSpinner({ message = 'Loading...', showProgress = false, progress = 0 }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      background: 'rgba(30, 41, 59, 0.8)',
      borderRadius: '8px',
      border: '1px solid rgba(148, 163, 184, 0.1)',
      margin: '20px 0'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid rgba(148, 163, 184, 0.2)',
        borderTop: '4px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '15px'
      }} />
      
      <div style={{
        fontSize: '14px',
        color: '#94a3b8',
        textAlign: 'center',
        maxWidth: '300px',
        lineHeight: '1.4'
      }}>
        {message}
      </div>
      
      {showProgress && (
        <div style={{
          width: '100%',
          maxWidth: '200px',
          height: '8px',
          background: 'rgba(148, 163, 184, 0.2)',
          borderRadius: '4px',
          marginTop: '10px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${progress}%`,
            height: '100%',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            borderRadius: '4px',
            transition: 'width 0.3s ease'
          }} />
        </div>
      )}
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default LoadingSpinner;
